import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_bespoke-events-3/artifacts/eegimh3d_Bon%20Evento%20logo.png";

const links = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Weddings", id: "portfolio" },
  { label: "Destinations", id: "destinations" },
  { label: "Testimonials", id: "testimonials" },
  { label: "Contact", id: "contact" },
];

const Logo = ({ size = "default" }) => {
  const isLarge = size === "large";
  return (
    <img
      src={LOGO_URL}
      alt="Bon Evento — Luxury Wedding Planner in Mumbai"
      data-testid="brand-logo"
      loading="eager"
      decoding="async"
      style={{ pointerEvents: "auto" }}
      className={`w-auto block transition-transform duration-500 hover:scale-[1.03] ${
        isLarge
          ? "h-28 md:h-36 max-w-[200px] md:max-w-[260px]"
          : "h-16 md:h-20 max-w-[140px] md:max-w-[170px]"
      }`}
    />
  );
};

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-navigation"
      role="banner"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#080B12]/80 border-b border-[#F0EBE1]/10 py-1"
          : "bg-transparent py-2"
      }`}
    >
      <nav
        aria-label="Primary"
        className="px-6 md:px-12 lg:px-20 flex items-center justify-between gap-6"
      >
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            handleNav("home");
          }}
          data-testid="logo-link"
          aria-label="Bon Evento — Luxury Wedding Planners in Mumbai"
          className="hover:opacity-90 transition-opacity flex-shrink-0"
        >
          <Logo />
        </a>

        <div className="hidden lg:flex items-center gap-7 xl:gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => handleNav(l.id)}
              className="text-[0.7rem] uppercase tracking-[0.26em] font-medium text-[#F0EBE1]/85 hover:text-[#B8935C] transition-colors whitespace-nowrap"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => handleNav("contact")}
          data-testid="nav-cta-btn"
          className="hidden lg:inline-flex items-center gap-2 px-6 py-3 bg-[#B8935C] text-[#080B12] text-[0.7rem] uppercase tracking-[0.28em] font-semibold hover:bg-[#D4AF37] shadow-[0_4px_20px_-6px_rgba(184,147,92,0.5)] hover:shadow-[0_8px_28px_-6px_rgba(184,147,92,0.7)] transition-all duration-500 flex-shrink-0"
        >
          Plan With Us
        </button>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-[#F0EBE1] p-2"
          aria-label="Toggle navigation menu"
          aria-expanded={open}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden absolute top-full left-0 right-0 bg-[#080B12]/97 backdrop-blur-xl border-t border-[#F0EBE1]/10"
        >
          <div className="px-6 py-8 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => handleNav(l.id)}
                className="text-left text-sm uppercase tracking-[0.28em] text-[#F0EBE1]/85 hover:text-[#B8935C]"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("contact")}
              data-testid="mobile-cta-btn"
              className="mt-2 self-start px-7 py-3 bg-[#B8935C] text-[#080B12] text-xs uppercase tracking-[0.28em] font-semibold"
            >
              Plan With Us
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export { Logo };
export default Navigation;
